import * as actionTypes from "../actions/actionTypes";

const initialState: {
  providers: {
    providerId: string;
    providerName: string;
    providerEntityType: string;
    providerLabels: string[];
    longitude: number;
    latitude: number;
    address: string;
    city: string;
    state: string;
    hospitalName: string;
    postalCode: string;
    phoneNumber: string;
    providerType: string;
    specialty: string[];
    isContracted: boolean;
    favoriteId: string;
    isFavorite: boolean;
    totalExperienceScore: number;
    distance: number;
    gender: string;
    experienceScore: {
      label: string;
      value: number;
    }[];
    quantrosScores: {
      category: string;
      scores: { name: string; order: number; score: number }[];
    }[];
    providerTypeId: number;
    specialtyId: number;
    medicareValue: number;
    npi: string;
    orgDistance: string;
    orgPostalCode: string;
    finderLabel:string;
  }[];
  error: boolean;
  loading: boolean;
  errorMessage: string;
} = {
  providers: [],
  error: false,
  loading: false,
  errorMessage: "",
};
const findProviderReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PROVIDERS_START: {
      return {
        ...state,
        error: false,
        loading: true,
        providers: initialState.providers,
        errorMessage: initialState.errorMessage,
      };
    }
    case actionTypes.FETCH_PROVIDERS_SUCCESS: {
      return {
        ...state,
        providers: action.providers,
        error: false,
        loading: false,
        errorMessage: initialState.errorMessage,
      };
    }
    case actionTypes.FETCH_PROVIDERS_FAILED: {
      return {
        ...state,
        error: true,
        loading: false,
        providers: initialState.providers,
        errorMessage: action.errorMessage,
      };
    }
    case actionTypes.RESET_SEARCH_PARAM: {
      return {
        ...state,
        providers: initialState.providers,
        error: initialState.error,
        loading: initialState.loading,
        errorMessage: initialState.errorMessage,
      };
    }
    default:
      return state;
  }
};
export default findProviderReducer;
